<template>
    <div>
        <Header></Header>
        <div class="row pageHeader py-3 mb-4 justify-content-between" v-if="showPageHeader">
            <h4 class="container my-auto">{{this.$ml.get('PROCESS_V2')}}</h4>
        </div>
        <div class="container">
            <div v-if="currentTab=='process'">
                <div class="d-flex justify-content-between align-items-center mb-2 mobilDirectionColumn" v-if="showPageHeader">
                    <div class="mobilMarginBottom8">
                        <button type="button" class="btn btn-crm-secondary h40 mobilWidth100" @click="currentTab='process'"><i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('PROCESS_V1')}}
                        </button>
                    </div>
                    <div class="d-flex align-items-center mobilDirectionColumn">
                        <!-- <button class="btn btn-danger mr-2" @click="currentTab='closed_processes'">Kapanan Süreçler</button> -->
                        <div class="currentTab mr-2 btn-group crmButonGroupsType h40 mobilMarginBottom8" v-if="isAdmin">
                            <button type="button" class="btn btn-click h40 currentTabLeft" @click="currentTab='all'" :class="{active:currentTab=='all'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('ALL_PROCESSES')}}
                            </button>
                            <button type="button" class="btn btn-click h40 currentTabRight" @click="currentTab='forms'" :class="{active:currentTab=='forms'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('FORMS')}}
                            </button>
                        </div>
                        <button v-if="canOpenProcess" type="button" class="btn bg-new-primary f-14 h40" @click="addProcess"><i class="fa fa-plus f-14 mr-2"></i>{{this.$ml.get('CREATE_PROCESS')}}</button>
        
                    </div>
                </div>
                <div >
                    <formProcess class="show-forms" @changeHeader="headerStatus"/>
                </div>
            </div>
            <!-- <div v-else-if="currentTab=='closed_processes'">
                <div class="d-flex justify-content-between align-items-center" v-if="showPageHeader">
                    <div>
                        <button type="button" class="btn processBtn" @click="currentTab='process'"><i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('PROCESS_V1')}}
                        </button>
                    </div>
                    <div class="d-flex align-items-center">
                        <button class="btn btn-danger mr-2" @click="currentTab='closed_processes'">Kapanan Süreçler</button>
                        <div class="currentTab mr-2" v-if="isAdmin">
                            <button type="button" class="btn currentTabLeft" @click="currentTab='all'" :class="{active:currentTab=='all'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('ALL_PROCESSES')}}
                            </button>
                            <button type="button" class="btn currentTabRight" @click="currentTab='forms'" :class="{active:currentTab=='forms'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('FORMS')}}
                            </button>
                        </div>
                        <button v-if="canOpenProcess" type="button" class="btn bg-new-primary f-14 h-100" @click="addProcess"><i class="fa fa-plus f-14 mr-2"></i>{{this.$ml.get('CREATE_PROCESS')}}</button>
                    </div>
                </div>
                <div class="mt-3">
                    <closedProcesses :user="user" :users="users"/>
                </div>
            </div> -->
            <div v-else-if="currentTab=='forms'">
                <div class="d-flex justify-content-between align-items-center mb-2 mobilDirectionColumn" v-if="showPageHeader">
                    <div class="mobilMarginBottom8">
                        <button type="button" class="btn btn-crm-secondary h40 mobilWidth100" @click="currentTab='process'"><i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('PROCESS_V1')}}
                        </button>
                    </div>
                    <div class="d-flex align-items-center mobilDirectionColumn">
                        <!-- <button class="btn btn-danger mr-2" @click="currentTab='closed_processes'">Kapanan Süreçler</button> -->
                        <div class="currentTab mr-2 btn-group crmButonGroupsType h40 mobilMarginBottom8" v-if="isAdmin">
                            <button v-if="isAdmin" type="button" class="btn btn-click h40 currentTabLeft" @click="currentTab='all'" :class="{active:currentTab=='all'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('ALL_PROCESSES')}}
                            </button>
                            <button type="button" class="btn btn-click h40 currentTabRight" @click="currentTab='forms'" :class="{active:currentTab=='forms'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('FORMS')}}
                            </button>
                        </div>
                        <button type="button" class="btn bg-new-primary f-14 h40" @click="addForm"><i class="fa fa-plus f-14 mr-2"></i>{{this.$ml.get('CREATE_FORM')}}</button>
                    </div>
                </div>
                <div >
                    <formGenerator class="show-forms" @changeHeader="headerStatus"/>
                </div>
            </div>
            <div v-else>
                <div class="d-flex justify-content-between align-items-center mb-2 mobilDirectionColumn" v-if="showPageHeader">
                    <div class="mobilMarginBottom8">
                        <button type="button" class="btn btn-crm-secondary h40 mobilWidth100" @click="currentTab='process'"><i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('PROCESS_V1')}}
                        </button>
                    </div>
                    <div class="d-flex align-items-center mobilDirectionColumn">
                        <!-- <button class="btn btn-danger mr-2" @click="currentTab='closed_processes'">Kapanan Süreçler</button> -->
                        <div class="currentTab mr-2 btn-group crmButonGroupsType h40 mobilMarginBottom8" v-if="isAdmin">
                            <button v-if="isAdmin" type="button" class="btn btn-click h40 currentTabLeft" @click="currentTab='all'" :class="{active:currentTab=='all'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('ALL_PROCESSES')}}
                            </button>
                            <button type="button" class="btn btn-click h40 currentTabRight" @click="currentTab='forms'" :class="{active:currentTab=='forms'}">
                                <i class="fab fa-wpforms mr-1"></i> {{this.$ml.get('FORMS')}}
                            </button>
                        </div>
                        <button type="button" class="btn bg-new-primary f-14 h40" @click="addProcess"><i class="fa fa-plus f-14 mr-2"></i>{{this.$ml.get('CREATE_PROCESS')}}</button>
                    </div>
                </div>
                <div >
                    <adminProcess class="show-forms" :user="user" :users="users"/>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import Header from './header'
    import formProcess from './formProcess.vue'
    import FormGenerator from './formGenerator.vue'
    import FormWorkflow from './formGeneratorFlow.vue'
    import AdminProcess from './processAdmin.vue'
    import closedProcesses from './closedProcesses.vue'
    
    export default {
        name: "Process",
        components: {
            Header,
            formProcess,
            FormGenerator,
            FormWorkflow,
            AdminProcess,
            closedProcesses
        },
        data () {
            return {
                currentTab: '',
                showList: true,
                showPageHeader: true,
                isAdmin: false,
                user: [],
                users: [],
                canOpenProcess:false
            }
        },
        computed:{
            ...mapState([
                'baseUrl'
            ]),
        },
        created() {
            this.$root.$refs.Process = this
        },
        methods: {
            addForm() {
                this.showPageHeader=false
                this.$root.$refs.formGenerator.changeStatu()
            },
            addProcess() {
                if(this.currentTab == "process"){
                    this.$root.$refs.formProcess.addProcessModal()
                }
                else{
                    this.$root.$refs.adminProcess.addProcessModal()
                }
            },
            headerStatus() {
                this.showPageHeader = true
            },
            getUsersF(){
                axios({
                    method:'POST',
                    url:'/getUsers',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.user = res.data.content.user
                            this.users = res.data.content.users
                            if(res.data.content.user.userRoleId == 1){
                                this.isAdmin = true
                                this.canOpenProcess = true
                            }
                            else{
                                this.isAdmin = false
                                this.getPermissionSetF(res.data.content.user.userRoleId)
                            }
                        }
                    }
                })
            },
            getPermissionSetF(userRoleId){
                axios({
                    method:'POST',
                    url:'/getPermissionSet',
                    data:{
                        roleId:userRoleId
                    },
                    baseURL: this.baseUrl,
                    withCredentials:true
                })
                .then((res)=>{
                    return res
                })
                .then((res)=>{
                    if(res.data.status.code==0){
                        if(res.data.content.permissionSet.permissions.includes("can_open_process")){
                            this.canOpenProcess = true
                        }
                    }
                })
            },
        },
        watch: {
            currentTab: function(val) {
                let el = document.getElementsByClassName("btn-crm-secondary")[0]
                if(val === "process") {
                    el.setAttribute("style", "background:#FFF; color: rgba(51, 51, 51, 0.8);")
                }
                else{
                    el.removeAttribute("style", "background:#FFF; color: rgba(51, 51, 51, 0.8);")
                }
            }
        },
        mounted() {
            this.currentTab = "process"
            this.getUsersF()
        },
    }
</script>

<style scoped>
    body {
        margin: 0 !important;
    }
    .pageHeader {
        background: #fff;
        color: #333333CC;
    }
    .btn {
        padding: 3px 10px;
    }
    .currentTab {
        display: inline-grid;
        grid-template-columns: 130px 130px;
        grid-gap: 1px;
        /* border: 0.5px solid #A8A6A6;*/
        background-color: #A8A6A6;
        color: rgba(65, 65, 65, 0.5);
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border-radius: 4px;
    }
    .currentTab .active {
        background: #FFFFFF;
        color: rgba(51, 51, 51, 0.8);
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
    }
    .currentTabLeft{
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .currentTabRight{
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
    }
    .processBtn {
        background: #EFEFEF;
        border: 0.5px solid #A8A6A6;
        color: rgba(65, 65, 65, 0.5);
        font-weight: 500;
    }
    @media(max-width: 750px){
        .show-forms{
            max-width: 500px;
        }
    }
    @media(max-width: 576px){
        .mobilDirectionColumn{
            flex-direction: column ;
            align-items: normal !important;
        }
        .mobilMarginBottom8{
            margin-bottom: 8px;
            margin-right: 0px !important;
        }
        .mobilWidth100{
            width: 100%;
        }
        .currentTab {
        display: inline-grid;
        grid-template-columns: 50% 50%;
        grid-gap: 1px;
        /* border: 0.5px solid #A8A6A6;*/
        background-color: #A8A6A6;
        color: rgba(65, 65, 65, 0.5);
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border-radius: 4px;
    }
    }
    @media(max-width: 768px){
        .btn-crm-secondary{
            background-color: #f2f2f2;
        }
        .btn-click{
            background-color: #f2f2f2;
        }
    }
</style>